import type { formValue, useEmojiPickerInput } from './emojiPickerInterfaces'

export default function useEmojiPickerInput(): useEmojiPickerInput {
  const form: formValue = {
    emoji: ''
  }

  const emojiSelected = (e: CustomEvent, close: () => void) => {
    form.emoji = e.detail.unicode
    close()
  }

  return {
    emojiSelected,
    form
  }
}
